import React from 'react';
import TagV2, { TagV2Variant } from '@zola/zola-ui/src/components/Tag/TagV2';
import type { Card as TCard } from 'pages/UniversalLanding/types';
import featureFlag from 'util/featureFlags';

import {
  Container,
  Intro,
  Title,
  SubTitle,
  Description,
  CardContainer,
  CarouselContainer,
  CarouselScrollContainer,
  StyledCardImage,
  ButtonV3Borderless,
  Actions,
  Tags,
} from './ShopByType.style';

const tableNumberCard: TCard = {
  image: '//images.zola.com/792f82de-3da6-4600-a9ba-ebe444dbb5d5',
  link: '/wedding-planning/table-numbers/shop',
  label: 'Table numbers',
  isNew: true,
};

interface CardProps {
  card: TCard;
}

export const Card: React.FC<CardProps> = ({ card }) => (
  <CardContainer>
    <a href={card.link}>
      <StyledCardImage src={card.image} alt={card.label} />
    </a>
    <Tags>{card.isNew ? <TagV2 variant={TagV2Variant.COVE}>New</TagV2> : null}</Tags>
    <Actions>
      <ButtonV3Borderless
        component="a"
        textTransform={false}
        variant="secondary"
        href={card.link}
        size="small"
      >
        {card.label}
      </ButtonV3Borderless>
    </Actions>
  </CardContainer>
);

export const ShopByType: React.FC = () => {
  const CardTypes: TCard[] = [
    {
      image: '//images.zola.com/d0ade6a6-1150-4ce6-8c2c-78b4cc6824d4',
      link: '/wedding-planning/place-cards/shop',
      label: 'Place cards',
    },
    {
      image: '//images.zola.com/b8908f46-3316-4b0d-85d5-c9c57b134945',
      link: '/wedding-planning/menus/shop',
      label: 'Menus',
    },
    {
      image: '//images.zola.com/c490e756-8110-47da-b6b8-71f5a4ac4c48',
      link: '/wedding-planning/programs/shop',
      label: 'Programs',
    },
    {
      image: '//images.zola.com/fb40c968-0c88-4bb3-a7d4-c29645c45762',
      link: '/shop/category/party-supplies-decor',
      label: 'Party Supplies & Decor',
    },
    {
      image: '//images.zola.com/75f456ee-1b0c-42b3-a967-02885564fd69',
      link: '/shop/category/wedding-gifts-favors',
      label: 'Gifts & Favors',
    },
    {
      image: '//images.zola.com/115a76fb-cf9c-459e-98b8-eebdda5a138e',
      link: '/shop/category/bridal-boutique',
      label: 'Bridal Boutique',
    },
  ];

  if (featureFlag.get('paperTableNumber')) {
    CardTypes.splice(1, 0, tableNumberCard);
  }

  return (
    <Container>
      <Intro>
        <SubTitle>Say &quot;I do&quot; in style</SubTitle>
        <Title>Wedding day paper</Title>
        <Description>All your wedding-day paper, all right here.</Description>
      </Intro>
      <CarouselContainer>
        <CarouselScrollContainer>
          {CardTypes.map((card, index) => (
            <Card key={index} card={card} />
          ))}
        </CarouselScrollContainer>
      </CarouselContainer>
    </Container>
  );
};
